import { FormData } from '../index'

const SUBMIT_URL = process.env.REACT_APP_MILITARY_HEARING_LOSS_ENDPOINT || '/military-hearing-loss/submit-lead'
// Prefer an explicit preview URL; otherwise derive it from submit-lead so Amplify
// staging/prod keep working without a new env var. A bare relative fallback hits
// the CRA host and returns HTML (<!doctype…), which surfaces as a JSON parse error.
const PREVIEW_URL =
    process.env.REACT_APP_API_HEARING_LOSS_PREVIEW ||
    (SUBMIT_URL.includes('/submit-lead')
        ? SUBMIT_URL.replace(/\/submit-lead(?:\?.*)?$/, '/preview-documents')
        : '/military-hearing-loss/preview-documents')

type ApiResult = {
    success: boolean
    data: any
    error: string | null
    code?: string
}

const postJson = async (url: string, body: FormData | Record<string, unknown>): Promise<ApiResult> => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })

        if (!response.ok) {
            let serverMessage = ''
            let serverCode = ''
            try {
                const errBody = await response.json()
                serverMessage = errBody?.message || ''
                serverCode = errBody?.code || ''
            } catch {
                serverMessage = ''
            }
            const error = new Error(serverMessage || `HTTP error! status: ${response.status}`) as Error & {
                code?: string
            }
            error.code = serverCode
            throw error
        }

        const data = await response.json()

        return {
            success: true,
            data,
            error: null,
        }
    } catch (error) {
        console.error('Form API call failed:', error instanceof Error ? error.message : 'Unknown error')

        return {
            success: false,
            data: null,
            error: error instanceof Error ? error.message : 'Unknown error occurred',
            code: error instanceof Error ? (error as Error & { code?: string }).code : undefined,
        }
    }
}

// No logging of the request or response: the form holds personal details and
// the response carries the signing token
export const submitFormData = async (formData: FormData | Record<string, unknown>, url: string = SUBMIT_URL) =>
    postJson(url, formData)

/** Unsigned pack preview for the lead-form signature step (no DB write on the server). */
export const previewFormDocuments = async (
    formData: FormData | Record<string, unknown>,
    url: string = PREVIEW_URL
) => postJson(url, formData)
